import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ValidationService } from '../../validation.service';
import { SnackbarService } from '../../snackbar.service';
import { HttpService } from '../../http.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { TimeService } from '../../time.service';
// import { WebcamComponent } from '../../webcam/webcam.component';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/storage.service';

export interface spotData {
    name: string;
    mobile: string;
    vehicle_number: string;
    vehicle_type: string;
    gps_id?: string;
    gps_provider?: string;
    has_smart_phone: boolean;
    password?: string;
    driver_licence_no: string;
    driver_licence_expiry_date: number;
    selectedCarrier?: string;
    dedicated_to?: string;
    carrier_type?: string;
    capacity?: string;
    materials: string[];
    preferred_zone?: string;
    preferred_location?: string;
    driver_image?: string;
    rc_laden?: number;
    vehicle_weight?: number;
    desired_weight?: number;
    engine_number?: string;
    chassis_number?: string;
    load?: string;
    registered_for: string[];
    owner_name?: string;
    owner_mobile?: string;
    diesel_tanks?: string;
    diesel_tank1?: number;
    diesel_tank2?: number;
    labour: number;
    tools?: any;
    remarks?: string;
    pos?: string;
    registrar?: string;
    is_dedicated_vehicle: boolean;
    monthly_subscription: boolean;
    is_carrier_entry?: boolean;
    driver_type: string;
    is_cement: boolean;
}

export interface spotCapacityData {
    capacity?: number;
    vehicle_qty?: number;
    rc_Laden_weight?: number;
    desired_weight?: number,
}


@Component({
    selector: 'app-assign-load-dashboard',
    templateUrl: './assign-load-dashboard.component.html',
    styleUrls: ['./assign-load-dashboard.component.scss']
})


export class AssignLoadDashboardComponent implements OnInit {
    loadData: any;
    showLoader = false;
    spotVehicleData: spotData = {
        name: '',
        mobile: '',
        vehicle_number: '',
        vehicle_type: '',
        has_smart_phone: false,
        driver_licence_no: '',
        driver_licence_expiry_date: 0,
        password: '',
        selectedCarrier: '',
        dedicated_to: '',
        preferred_zone: '',
        preferred_location: '',
        materials: [],
        chassis_number: '',
        engine_number: '',
        registered_for: [],
        owner_name: '',
        owner_mobile: '',
        diesel_tanks: '',
        diesel_tank1: 0,
        diesel_tank2: 0,
        labour: 0,
        tools: false,
        //remarks: '',
        pos: '',
        registrar: '',
        is_dedicated_vehicle: false,
        monthly_subscription: false,
        driver_type: '',
        is_cement: false,
    };
    carrierTypes: any = ['CT', 'PT', 'PAT'];
    diesel_tanks: any = ['Single', 'Double'];
    diesel_tank1: any;
    diesel_tank2: any;
    engine_type: any;
    driverTypes: any = [
        {
            name: 'Own',
            value: 'own'
        },
        {
            name: 'Market',
            value: 'temporary'
        }
    ];
    carrier_type: any = 'CT';
    capacityData: spotCapacityData = {
        capacity: 0,
        vehicle_qty: 0,
        rc_Laden_weight: 0,
        desired_weight: 0,
    };
    preferred = {
        zone: '',
        location: '',
        load: '',
    };
    selectedVehicle = '';
    confirmPassword;
    showVerifyLinks;
    selectedPos: any;
    expiryDate;
    spinner = false;
    checked = false;
    selectedVehicleType: any = {};
    vehicleType: any = {};
    vehicles: any = [];
    vehicle_pattern;
    defaultVehicle: any;
    shippersArr: any = [];
    searchVehicleNo = '';
    assets;
    labourCount: any = [1, 2, 3, 4];
    accessories = ['Yes', 'No'];
    assetsArray;
    selectedGPSProvider;
    selectedAsset;
    showGPSProvider = false;
    gps_providers = [];
    gps_providers_all = [];
    ksaGpsProviders = [];
    inGpsProviders = [];
    gpsProviders: any = [];
    type;
    carrierList: any;
    vehicleTypes: any;
    vehicleType1: any;
    country: string;
    states: any = [];
    stream: MediaStream;
    driverImage: any;
    assignArr = [];
    vehicle_number = '';
    //comments = '';
    remarks = '';
    registrar = '';
    materialsArr: any[];
    allRegistrarsArr = [];
    filteredRegistrars = [];
    searchRegistrars = [];
    dedicatedName: any;
    shipperName: any;
    customer_name = '';
    registered_for: any = [];
    owner_name: any;
    owner_mobile: any;
    material = [];
    selectedMaterial = [];
    materialList: any = [{ name: '', load: 0 }];
    parital_vehicle_number = '';
    language = [
        { name: "Bengali", value: "bengali" },
        { name: "Gujarati", value: "gujarati" },
        { name: "Hindi", value: "hindi" },
        { name: "Kannada", value: "kannada" },
        { name: "Oriya", value: "oriya" },
        { name: "Tamil", value: "tamil" },
        { name: "Telugu", value: "telugu" }
    ];
    vehicleRegNumbers = [];
    selected = '';
    lin: any;
    lin_number: any;
    selectedLin = '';
    linCarrierDetails: any;
    liin: any;
    load_id: any;
    driverDob: any;
    insurance: any = {
        no: '',
        expiry: '',
    };
    enbleMaterial = true;
    // isDeleteDriver = false;
    messageDeleteStatus = '';
    selectedVehicleNo: any[];
    searchedArr: string[];
    searchingArr: any;
    searchingValue: string;
    searchedRegisterFor: any;
    searcheReg_for: any;
    searchedVehicleType: any;
    vehicle_qty: any;
    rc_Laden_weight: any;
    dlIssueDate: any;
    enableExpiryEditing: boolean = false;
    sarathiPhoto: any = '';
    licence_expiry: any;
    sarathi_image: any;
    showMonthlySubscription: boolean = false;
    monthlySubscription: boolean | null = null;
    accepted_quantity: any = 0;
    customer_location: any = '';
    is_vehicle_verified: boolean = false;
    is_driver_verified: boolean = false;
    GPSId: any;
    GPSProvider: any;
    materialName: any;
    vehicleTypeCement: any;
    isCement: boolean = false;
    isMobileHeaderCollapsed = true;

    constructor(
        private http: HttpService,
        private router: Router,
        private valid: ValidationService,
        private snackbar: SnackbarService,
        private timeService: TimeService,
        private translate: TranslateService,
        private storage: StorageService
    ) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation && navigation.extras && navigation.extras.state) {
            this.loadData = navigation.extras.state['loadData'];
        }
    }

    ngOnInit() {
        this.load_id = this.loadData ? this.loadData.load_id : '';
        this.lin_number = this.loadData ? this.loadData.LIN : '';
        if (!this.load_id || !this.lin_number) {
            this.router.navigate(['loadDashboard']);
        };
        this.accepted_quantity = this.loadData ? this.loadData.quantity : 0;
        this.customer_name = this.loadData ? this.loadData.customer_name : '';
        this.customer_location = this.loadData ? this.loadData.customer_location : '';
        this.materialName = this.loadData ? this.loadData.materials : '';
        this.materialList[0] = {
            name: this.loadData ? this.loadData.materials : '',
            load: this.loadData ? this.loadData.quantity : 0,
        }
        this.vehicleTypeCement = this.loadData ? this.loadData.vehicle_type : '';
        this.isCement = this.loadData ? this.loadData.is_cement : false;
        let selectedCarrier: string = '';

        selectedCarrier = this.storage.getFromCookie('carrier_id');
        if (!selectedCarrier) {
            const carriersString = localStorage.getItem('carriers');
            const carriersArray = carriersString ? JSON.parse(carriersString) : [];
            console.log('carriersArray', carriersArray);
            selectedCarrier = carriersArray[0]._id;
        }
        this.spotVehicleData.selectedCarrier = selectedCarrier;
        this.getData();
        this.getVehicleTypes();
        this.getGPSProviders();
        this.getShippers();
        this.getAllRegistrars();
        this.getCarriers();
        this.getZones();
        this.vehicle_pattern = environment.vehicle_pattern;
    }

    routeBack() {
        if (!this.isCement) {
            this.router.navigate(['loadDashboard']);
        } else {
            this.router.navigate(['cementLoadDashboard']);
        }
    }

    toggleMobileHeader() {
        this.isMobileHeaderCollapsed = !this.isMobileHeaderCollapsed;
    }

    getData() {
        this.showLoader = true;
        this.http.get('constants').subscribe(
            (response: any) => {
                this.showLoader = false;
                if (response.statusCode === 200) {
                    const result = response.data;
                    console.log('result', result);
                    const gps =
                        result &&
                            result.gps &&
                            result.gps.length > 0 ?
                            result.gps[0] : '';
                    console.log('gps', gps);
                    this.GPSId = gps ? gps._id : '';
                    this.GPSProvider = gps ? gps.value : '';
                    this.spotVehicleData.gps_id = gps ? gps._id : '';
                    this.spotVehicleData.gps_provider = gps ? gps.value : '';
                    this.selectedGPSProvider = gps ? gps.value : '';
                }
            },
            (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
                this.showLoader = false;
                if (err.error.statusCode == 401) {
                    this.valid.logout();
                }
            }
        );
    }

    getVehicleTypes() {
        this.showLoader = true;
        this.http.get('v1/captain/vehicle_type/all', '').subscribe((response: any) => {
            this.vehicles = [];
            if (response.statusCode == 200) {
                this.showLoader = false;
                response.data && response.data.data && response.data.data.forEach((element) => {
                    this.vehicles.push({
                        value: element._id,
                        viewValue: element.name,
                    });
                });
                this.vehicleTypes = this.vehicles;
                this.searchedVehicleType = this.vehicles;
            }
        }, (err: any) => {
            this.snackbar.openSnackBar(err.error.message, '', 'err');
            this.showLoader = false;
            if (err.error.statusCode == 401) {
                this.valid.logout();
            }
        });
    }

    // getGPSProviders() {
    //     this.showLoader = true;
    //     const payload = {
    //         name: 'gps_providers',
    //     };
    //     this.http.get('v1/captain/constants/get_gps_providers', payload).subscribe(
    //         (response: any) => {
    //             if (response.statusCode == 200) {
    //                 console.log(response.data, "gps_providers");
    //                 this.showLoader = false;
    //                 const data = response.data && response.data.data;
    //                 this.gps_providers = data && data.length > 0 ? data[0].value : '';
    //             }
    //         },
    //         (err: any) => {
    //             this.showLoader = false;
    //             this.snackbar.openSnackBar(err.error.message, '', 'err');
    //             if (err.error.statusCode == 401) {
    //                 this.valid.logout();
    //             }
    //         }
    //     );
    // }

    getMaterials() {
        this.showLoader = true;
        this.http.get('v1/captain/constants/materials', { shipper: this.spotVehicleData.dedicated_to }).subscribe(
            (response: any) => {
                if (response.statusCode === 200) {
                    this.showLoader = false;
                    this.materialsArr = [];
                    const result = response.data && response.data.data;
                    result && result.length > 0 && result.forEach((element, i) => {
                        const temp: any = {};
                        temp._id = element._id;
                        temp.name = element.name;
                        this.materialsArr.push(temp);
                    });
                }
            },
            (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
                this.showLoader = false;
                if (err.error.statusCode == 401) {
                    this.valid.logout();
                }
            }
        );
    }

    validate(data) {
        const loadUpperCap = (this.spotVehicleData.vehicle_weight - this.spotVehicleData.rc_laden) * 1.05;
        const loadLowerCap = (this.spotVehicleData.vehicle_weight - this.spotVehicleData.rc_laden) * 0.95;
        const desiredWeightUpperCap = (this.spotVehicleData.vehicle_weight - this.spotVehicleData.rc_laden) * 1.1;
        const desiredWeightLowerCap = (this.spotVehicleData.vehicle_weight - this.spotVehicleData.rc_laden) * 0.9;

        this.spotVehicleData.password = this.spotVehicleData.mobile;
        this.confirmPassword = this.spotVehicleData.mobile;
        console
        if (
            !this.valid.isEmpty(this.spotVehicleData.name) &&
            !this.valid.isEmpty(this.spotVehicleData.mobile) &&
            !this.valid.isEmpty(this.spotVehicleData.vehicle_number) &&
            !this.valid.isEmpty(this.spotVehicleData.password) &&
            !this.valid.isEmpty(this.spotVehicleData.vehicle_type) &&
            !this.valid.isEmpty(this.confirmPassword) &&
            !this.valid.isEmpty(this.spotVehicleData.driver_licence_no) &&
            new Date(this.spotVehicleData.driver_licence_expiry_date).getTime() > 0 &&
            this.spotVehicleData.registered_for.length > 0 &&
            !this.valid.isEmpty(this.spotVehicleData.owner_mobile) &&
            !this.valid.isEmpty(this.spotVehicleData.owner_name)
        ) {
            if (
                environment.country == 'IN' &&
                !this.valid.isVehicle(this.spotVehicleData.vehicle_number)
            ) {
                this.snackbar.openSnackBar(
                    this.translate.instant('Enter valid vehicle number'),
                    '',
                    'err'
                );
                return false;
            } else if (
                (environment.country == 'SA' || environment.country == 'BR') &&
                !this.valid.isKsaVehicle(this.spotVehicleData.vehicle_number)
            ) {
                this.snackbar.openSnackBar(
                    this.translate.instant('Enter valid vehicle number'),
                    '',
                    'err'
                );
                return false;
            } else if (!this.valid.isMobile(this.spotVehicleData.mobile)) {
                this.snackbar.openSnackBar(
                    this.translate.instant('Enter valid mobile number'),
                    '',
                    'err'
                );
                return false;
            } else if (this.spotVehicleData.driver_type === '') {
                this.snackbar.openSnackBar(
                    this.translate.instant('Please select driver type'),
                    '',
                    'err'
                );
                return false;
            } else if (this.spotVehicleData.vehicle_weight > 90) {
                this.snackbar.openSnackBar(
                    this.translate.instant('Vehicle RC Gross Passing Weight cannot be greater than 90 MT'),
                    '',
                    'err'
                );
                return false;
            } else if (this.spotVehicleData.rc_laden > (this.capacityData.vehicle_qty * 95 / 100)) {
                this.snackbar.openSnackBar(
                    this.translate.instant(`Vehicle RC Laden Weight cannot be greater than ${(this.capacityData.vehicle_qty * 95 / 100)} MT`),
                    '',
                    'err'
                );
                return false;
            } else if (parseInt(this.spotVehicleData.capacity) > loadUpperCap) {
                this.snackbar.openSnackBar(
                    this.translate.instant(`Load cannot be greater than ${loadUpperCap} MT`),
                    '',
                    'err'
                );
                return false;
            } else if (this.spotVehicleData.desired_weight > desiredWeightUpperCap) {
                this.snackbar.openSnackBar(
                    this.translate.instant(`Desired Weight cannot be greater than ${desiredWeightUpperCap} MT`),
                    '',
                    'err'
                );
                return false;
            }

        } else {
            this.snackbar.openSnackBar(
                this.translate.instant('Please enter all the mandatory fields'),
                '',
                'err'
            );
            return false;
        }
        return true;
    }

    selectVehicleType(event) {
        if (!event.checked) {
            this.vehicleType.id = this.selectedVehicleType.id;
            this.vehicleType.name = this.selectedVehicleType.name;
        } else {
            this.vehicleType.id = '';
            this.vehicleType.name = '';
        }
    }

    selectDriverType(type: string) {
        this.showMonthlySubscription = this.isCement && type === 'temporary';
        if (type === 'temporary' && !(this.selectedGPSProvider && this.selectedGPSProvider === '')) {
            this.selectGPSProvider('instavans');
            this.GPSId = "Instavans";
            this.gps_providers = [{
                name: 'Instavans',
                value: 'instavans'
            }];
            return;
        } else if (type === 'own') {
            this.selectGPSProvider('');
            this.gps_providers = [...this.gps_providers_all];
            console.log('this.gps_providers_all', this.gps_providers_all, this.gps_providers);
        }
    }

    getGPSProviders() {
        console.log('>>')
        this.http.get('constants/carrier', '', 3).subscribe(
            (data: any) => {
                if (data.statusCode == 200) {

                    if (data.data.gps.length) {
                        this.gps_providers_all = data.data.gps;
                    }
                }
            },
            (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
            }
        );
    }

    setExpiryDate(date, change = '', type) {
        if (!change) {
            const temp: any = this.timeService.IsoToUTC(date);
            if (type == 'licence_expiry') {
                this.spotVehicleData.driver_licence_expiry_date = temp.ts;
            } else {
                this.insurance.expiry = temp.ts;
            }
        } else {
            if (type == 'licence_expiry') {
                this.spotVehicleData.driver_licence_expiry_date = this.timeService.toUTCEpoch(date);
            } else {
                this.insurance.expiry = this.timeService.toUTCEpoch(date);
            }
        }
    }

    addOwnVehicle() {
        if (this.spotVehicleData.chassis_number.length <= 12) {
            this.snackbar.openSnackBar("Please enter the valid chassis number", '', 'err');
            return;
        }
        if (new Date(this.driverDob) > new Date() && new Date().getFullYear() - new Date(this.driverDob).getFullYear() < 18) {
            this.snackbar.openSnackBar("Enter valid date of birth", '', 'err');
            return;
        }
        if (this.showMonthlySubscription && this.monthlySubscription === null) {
            this.snackbar.openSnackBar("Please select Monthly Subscription", '', 'err');
            return;
        }
        this.spotVehicleData.is_carrier_entry = true;
        this.spotVehicleData.vehicle_type = this.vehicleType.id;
        this.spotVehicleData.vehicle_type = this.selectedVehicle;
        this.spotVehicleData.carrier_type = 'CT';
        this.spotVehicleData.capacity = this.capacityData.capacity.toString();
        if (this.capacityData.rc_Laden_weight)
            this.spotVehicleData.rc_laden = this.capacityData.rc_Laden_weight;
        if (this.capacityData.desired_weight)
            this.spotVehicleData.desired_weight = this.capacityData.desired_weight;
        if (this.capacityData.vehicle_qty)
            this.spotVehicleData.vehicle_weight = this.capacityData.vehicle_qty;
        if (this.driverImage) this.spotVehicleData.driver_image = this.driverImage;
        if (this.customer_name) this.spotVehicleData['customer_name'] = this.customer_name;
        if (this.remarks) this.spotVehicleData['remarks'] = this.remarks;
        if (this.registrar) this.spotVehicleData['registrar'] = this.registrar;
        if (this.insurance) this.spotVehicleData['insurance'] = this.insurance;
        if (this.registered_for.length) this.spotVehicleData['registered_for'] = this.registered_for;
        if (this.owner_name) this.spotVehicleData['owner_name'] = this.owner_name;
        if (this.owner_mobile) this.spotVehicleData['owner_mobile'] = this.owner_mobile;
        if (this.driverDob) this.spotVehicleData['driver_dob'] = this.driverDob;
        this.spotVehicleData.materials = this.materialList;
        if (this.engine_type) this.spotVehicleData['diesel_tanks'] = this.engine_type;
        if (this.diesel_tank1) this.spotVehicleData['diesel_tank1'] = this.diesel_tank1;
        if (this.diesel_tank2 && this.engine_type === 'Double') this.spotVehicleData['diesel_tank2'] = this.diesel_tank2;
        if (this.selectedPos) this.spotVehicleData['pos'] = this.selectedPos;
        if (this.licence_expiry) this.spotVehicleData['driver_licence_expiry_date'] = this.licence_expiry;
        const valid = this.validate(this.spotVehicleData);
        let url = '';
        url = 'v1/captain/driverCement/add_driver';
        if (this.selectedGPSProvider) this.spotVehicleData.gps_provider = this.selectedGPSProvider;
        if (this.showMonthlySubscription) this.spotVehicleData.monthly_subscription = this.monthlySubscription;
        else {
            delete this.spotVehicleData.gps_provider;
            delete this.spotVehicleData.gps_id;
        }
        if (this.load_id) this.spotVehicleData.load = this.load_id;
        this.spotVehicleData.tools = this.spotVehicleData.tools === 'Yes' ? true : false;
        this.spotVehicleData.is_cement = this.isCement;
        if (valid) {
            console.log("🚀 ~ file: add-own-vehicle.component.ts:404 ~ AddOwnVehicleComponent ~ addOwnVehicle ~ valid:", this.spotVehicleData);
            this.showLoader = true;
            this.http.post(url, this.spotVehicleData).subscribe(
                (response: any) => {
                    if (response.statusCode === 200) {
                        this.showLoader = false;
                        this.messageDeleteStatus = '';
                        this.snackbar.openSnackBar(
                            this.translate.instant('Vehicle Added Successfully')
                        );
                        this.routeBack();
                    }
                },
                (err: any) => {
                    this.showLoader = false;
                    this.snackbar.openSnackBar(err.error.message, '', 'err');
                    if (err.error.statusCode == 401) {
                        this.valid.logout();
                    }
                }
            );
        }
    }

    // populate assets when provider is selected
    selectGPSProvider(provider) {
        this.selectedGPSProvider = provider;
    }

    selectAsset(asset) {
        this.selectedAsset = asset.reg_number;
        if (asset.asset_id) this.spotVehicleData.gps_id = asset.asset_id;
    }

    applyFilter(value: string) {
        if (value) {
            this.assets = this.assets.filter((option) =>
                option.reg_number.includes(value)
            );
        } else {
            this.assets = this.assetsArray;
        }
    }

    selectVehicle(vehicle) {
        this.vehicleType.id = vehicle._id;
        this.vehicleType.name = vehicle.name;
    }

    openVerifyModal(url) {
        window.open(url, '_blank');
    }

    addCapacity(value) {
        let data = this.capacityData;
        this.capacityData.capacity =
            parseFloat((this.capacityData.vehicle_qty - this.capacityData.rc_Laden_weight).toFixed(2));
    }

    getShippers() {
        this.showLoader = true;
        const shipper = this.loadData.shipperId;
        this.spotVehicleData.dedicated_to = shipper;
        if (shipper === "66cb78e108583b1fa294d901") {
            this.showMonthlySubscription = true;
        } else {
            this.showMonthlySubscription = false;
        }
        this.spotVehicleData.registered_for = [shipper];
        this.enbleMaterial = true
        this.showLoader = false;
        // this.http.get('v1/captain/shippers', '').subscribe(
        //     (response: any) => {
        //         if (response.statusCode === 200) {
        //             this.showLoader = false;
        //             this.shippersArr = [];
        //             const result = response.data && response.data.data;
        //             result && result.length > 0 && result.forEach((element, i) => {
        //                 const temp: any = {};
        //                 temp._id = element._id;
        //                 temp.name = element.name;
        //                 this.shippersArr.push(temp);
        //                 this.searchedRegisterFor = this.shippersArr;
        //             });
        //             if(!this.isCement){
        //                 this.dedicatedName = "PHASE II LOGISTICS PARKING AREA";
        //                 this.shipperName = "PHASE II LOGISTICS PARKING AREA";
        //             } else {
        //                 this.dedicatedName = "9087 - JINDAL PANTHER CEMENT";
        //                 this.shipperName = "9087 - JINDAL PANTHER CEMENT";
        //             }
        //             const shipperID = this.shippersArr && 
        //             this.shippersArr.length > 0 && 
        //             this.shippersArr.find((element: any) => element.name === this.dedicatedName)._id;


        //             console.log(this.registered_for, "this.registered_for");
        //             console.log(this.spotVehicleData.dedicated_to, "this.spotVehicleData.dedicated_to");
        //             this.enbleMaterial = false;
        //             this.getMaterials();
        //         }
        //     },
        //     (err: any) => {
        //         this.snackbar.openSnackBar(err.error.message, '', 'err');
        //         this.showLoader = false;
        //         if (err.error.statusCode == 401) {
        //             this.valid.logout();
        //         }
        //     }
        // );
    }

    getAllRegistrars() {
        this.showLoader = true;
        this.http.get('v1/captain/getAllRegistrars', '').subscribe(
            (response: any) => {
                if (response.statusCode === 200) {
                    this.showLoader = false;
                    this.allRegistrarsArr =
                        response.data &&
                        response.data.data &&
                        response.data.data.value &&
                        response.data.data.value.map((element) => ({ name: element.value }));
                    this.filteredRegistrars =
                        this.allRegistrarsArr &&
                        this.allRegistrarsArr.length > 0 &&
                        this.allRegistrarsArr.map(registrar => registrar.name);
                    this.searchRegistrars = [...this.filteredRegistrars];
                }
            },
            (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
                this.showLoader = false;
                if (err.error.statusCode == 401) {
                    this.valid.logout();
                }
            }
        );
    }

    getCarriers() {
        this.carrierList = [];
        this.showLoader = true;
        this.http.get('v1/captain/carriers/get', '').subscribe((response: any) => {
            if (response.statusCode == 200) {
                this.showLoader = false;
                const carriers: any = response.data && response.data.data;
                carriers && carriers.length > 0 && carriers.forEach((element) => {
                    if (element.verified) {
                        const temp: any = {};
                        temp._id = element._id;
                        temp.parent_name = element.parent_name
                            ? element.parent_name
                            : 'N/A';
                        temp.shortName = element.name ? element.name : 'N/A';
                        if (element.erp_reference && element.erp_reference.length) {
                            const vendor = element.erp_reference[0];
                            if (vendor.reference_id) {
                                temp.vendor_code = vendor.reference_id;
                            }
                        }
                        temp.name = `${temp.parent_name} - ${temp.shortName}`;
                        this.carrierList.push(temp);
                    }
                });
            }
        }, (err: any) => {
            this.snackbar.openSnackBar(err.error.message, '', 'err');
            this.showLoader = false;
            if (err.error.statusCode == 401) {
                this.valid.logout();
            }
        });
    }

    sub(value) {
        let data = this.capacityData;
        this.capacityData.capacity = parseFloat((this.capacityData.vehicle_qty - this.capacityData.rc_Laden_weight).toFixed(2));
        this.capacityData.desired_weight = parseFloat((this.capacityData.vehicle_qty - this.capacityData.rc_Laden_weight).toFixed(2));
        if (this.materialList.length) {
            this.materialList[0].name = this.materialName;
            this.materialList[0].load = this.capacityData.capacity;
        }
    }

    validateVehicleNo(selectedVehicleNo) {
        if (
            environment.country == 'IN' &&
            !this.valid.isVehicle(selectedVehicleNo)
        ) {
            this.snackbar.openSnackBar(
                this.translate.instant('Enter valid vehicle number'),
                '',
                'err'
            );
            return false;
        } else if (
            (environment.country == 'SA' || environment.country == 'BR') &&
            !this.valid.isKsaVehicle(selectedVehicleNo)
        ) {
            this.snackbar.openSnackBar(
                this.translate.instant('Enter valid vehicle number'),
                '',
                'err'
            );
            return false;
        }
        return true;
    }

    getZones() {
        this.showLoader = true;
        // const country = JSON.parse(this.storage.getFromLocalStorage('country'));
        const payload = {
            country: "5daf0130f22e5921af301785",
        };
        this.http.get('v1/captain/admin/stateDetails', payload).subscribe(
            (response: any) => {
                if (response.statusCode == 200) {
                    this.showLoader = false;
                    if (response.data) {
                        this.states = response.data && response.data.data;
                    }
                }
            },
            (err: any) => {
                this.showLoader = false;
                this.snackbar.openSnackBar(err.error.message, '', 'err');
                if (err.error.statusCode == 401) {
                    this.valid.logout();
                }
            }
        );
    }

    searchVehicleDetails() {
        this.showLoader = true;
        const valid = this.validateVehicleNo(this.vehicle_number);
        if (valid) {
            const payload = {
                is_free: false,
                is_deleted: true,
                vehicle_no: this.vehicle_number,
                limit: 1
            }
            this.spotVehicleData.vehicle_number = this.vehicle_number;

            this.http.get('v1/captain/driver/get_all_attached', payload).subscribe(
                (response: any) => {
                    if (response.statusCode === 200) {
                        this.is_vehicle_verified = true;
                        this.showLoader = false;
                        this.clearData();
                        this.assignArr = [];
                        this.assignArr.length = 0;
                        if (response.data.data.drivers.length > 0) {
                            const result = response.data.data.drivers[0];
                            this.spotVehicleData.name = result.name;
                            this.spotVehicleData.remarks = result.remarks;
                            this.spotVehicleData.registrar = result.registrar;
                            this.spotVehicleData.mobile = result.mobile;
                            if (result.licence) this.spotVehicleData.driver_licence_no = result.licence.no;
                            // this.carrier_type = result.carrier_type;
                            this.capacityData.vehicle_qty = result.vehicle_weight;
                            if (result.driver_image) this.driverImage = result.driver_image.name;
                            this.capacityData.rc_Laden_weight = result.rc_laden;
                            this.capacityData.desired_weight = this.capacityData.vehicle_qty - this.capacityData.rc_Laden_weight;
                            this.capacityData.capacity = parseFloat(this.capacityData.desired_weight.toFixed(2));
                            this.selectedVehicle = result.vehicle_type._id;
                            if (result.licence && result.licence.expiry_date) this.expiryDate = result.licence.expiry_date || '';
                            this.spotVehicleData.driver_licence_expiry_date = result.licence ? result.licence.expiry_date : '';
                            this.engine_type = result.diesel_tanks ? result.diesel_tanks : '';
                            this.diesel_tank1 = result.diesel_tank1 ? result.diesel_tank1 : '';
                            if (result.diesel_tanks === 'Double') this.diesel_tank2 = result.diesel_tank2 ? result.diesel_tank2 : '';
                            this.selectedPos = result.pos;
                            if (result.expiryDate) this.setExpiryDate(this.expiryDate, 'change', 'licence_expiry');
                            this.spotVehicleData.gps_provider = this.selectedGPSProvider;
                            this.spotVehicleData.gps_id = result.gps ? result.gps.asset_id : this.GPSId;
                            this.spotVehicleData.materials = result.material;
                            this.spotVehicleData.preferred_location = result.preferred_location;
                            this.spotVehicleData.preferred_zone = result.preferred_zone;
                            if (result.insurance) this.insurance.no = result.insurance.no;
                            if (result.insurance) this.insurance.expiry = result.insurance.expiry;
                            this.spotVehicleData.engine_number = result.engine_number;
                            this.spotVehicleData.chassis_number = result.chassis_number;
                            this.selectedGPSProvider = result.gps ? result.gps.provider : '';
                            if (!this.selectedGPSProvider) {
                                this.selectedGPSProvider = this.GPSProvider;
                            }
                            this.driverDob = result.driver_dob;
                            if (result.vehicle && result.vehicle.owner_name) {
                                if (result.owner_name) this.spotVehicleData.owner_name = result.vehicle.owner_name;
                                this.spotVehicleData.owner_mobile = result.vehicle.owner_mobile;
                            }
                            else {
                                if (result.owner_name) this.spotVehicleData.owner_name = result.owner_name;
                                this.spotVehicleData.owner_mobile = result.owner_mobile;
                            }
                            if (result.vehicle && result.vehicle.is_dedicated_vehicle) {
                                this.spotVehicleData.is_dedicated_vehicle = true;
                            }
                            // this.shipperName = this.shippersArr.filter(item => {
                            //     if (item._id == result.registered_for)
                            //         return item.name;
                            // });
                        } else {
                            this.snackbar.openSnackBar('No Data Found', '', 'err');
                        }
                        this.getRcPassingTareWeight(payload.vehicle_no);
                    }
                },
                (err: any) => {
                    this.is_vehicle_verified = false;
                    this.snackbar.openSnackBar(err.error.message, '', 'err');
                    this.showLoader = false;
                    if (err.error.statusCode == 401) {
                        this.valid.logout();
                    }
                }
            );
        }
    }

    clearData() {
        this.selectedVehicleNo = [];
        this.spotVehicleData.name = '';
        this.spotVehicleData.mobile = '';
        this.spotVehicleData.remarks = '';
        this.spotVehicleData.registrar = '';
        this.spotVehicleData.driver_licence_no = '';
        this.carrier_type = '';
        this.capacityData.vehicle_qty = 0;
        this.capacityData.rc_Laden_weight = 0;
        this.capacityData.desired_weight = 0;
        this.capacityData.capacity = 0;
        this.selectedVehicle = '';
        this.expiryDate = '';
        this.registered_for = [];
        this.remarks = '';
        this.registrar = '';
        this.spotVehicleData.chassis_number = '';
        this.spotVehicleData.engine_number = '';
        this.insurance.no = '';
        this.insurance.expiry = '';
        this.driverDob = '';
    }

    selectMaterial(mat, event, i) {
        let names = this.materialList.filter(x => x.name == event.source.value);

        if (names.length > 0 && this.materialList[i].name != event.source.value) {
            this.snackbar.openSnackBar(this.translate.instant('Material already selected. Please choose different material'), '', 'err');
            event.source.deselect();

        }
    }

    selectShipper(ship, event) {
        if (event.source._selected && this.registered_for.indexOf(ship._id) == -1) {
            this.registered_for.push(ship._id);
        } else if (this.registered_for.indexOf(ship._id) != -1) {
            this.registered_for.splice(this.registered_for.indexOf(ship._id), 1);
        }
    }

    addMaterial() {
        if (this.materialList.length < this.materialsArr.length)
            this.materialList.push({ name: '', load: 0 });
    }

    removeMaterial(i) {
        this.materialList.splice(i, 1);
    }

    deleteSpot() {
        this.showLoader = true;
        let data: any = {
            mobile: this.spotVehicleData.mobile
        };
        if (this.messageDeleteStatus.indexOf('Search by vehicle') !== -1) {
            data = {
                vehicle_no: this.spotVehicleData.vehicle_number
            };
        }
        this.http.post('v1/captain/driver/remove_driver', data).subscribe(
            (response: any) => {
                if (response.statusCode == 200) {
                    this.showLoader = false;
                    this.messageDeleteStatus = '';
                    const data = response.data && response.data.data;
                    this.snackbar.openSnackBar(data, '', 'success');
                }
            },
            (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
                this.showLoader = false;
                if (err.error.statusCode == 401) {
                    this.valid.logout();
                }
            }
        );
    }

    fetchGps() {
        this.showLoader = true;
        const payload = {
            REG_number: this.vehicle_number || this.spotVehicleData.vehicle_number,
            isBypass: true,
        }
        this.http.get('v1/captain/vehicle/get', payload).subscribe(
            (response: any) => {
                if (response.statusCode == 200) {
                    this.showLoader = false;
                    if (response.data && response.data.data && response.data.data.gps && response.data.data.gps.provider) {
                        this.selectedGPSProvider = response.data.data.gps.provider;
                    }
                    else {
                        this.selectedGPSProvider = this.GPSProvider;
                        this.spotVehicleData.gps_provider = this.GPSProvider;
                        this.spotVehicleData.gps_id = this.GPSId;
                        this.snackbar.openSnackBar('No Gps Found from fetching', '', 'err');
                    }
                }
            },
            (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
                this.showLoader = false;
                if (err.error.statusCode == 401) {
                    this.valid.logout();
                }
            });
    }

    getVehiclesDetails() {
        this.showLoader = true;
        this.http.get('v1/captain/vehicleRegisterNumber', '').subscribe(
            (response: any) => {
                if (response.statusCode == 200) {
                    this.vehicleRegNumbers = response.data && response.data.data;
                    this.selectedVehicleNo = response.data && response.data.data;
                    this.showLoader = false;
                }
            },
            (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
                this.showLoader = false;
                if (err.error.statusCode == 401) {
                    this.valid.logout();
                }
            }
        );
    }

    search(query: string) {
        let result = this.filterRegNumber(query)
        this.searchedArr = result;
    }

    filterRegNumber(query: string): string[] {
        return this.searchingArr.filter(v => v.toLowerCase().indexOf(query.toLowerCase()) > -1)
    }

    elasticSearch(filterValue: string) {
        if (filterValue.length === 0) {
            // Show all options if the input is empty
            this.searchRegistrars = this.filteredRegistrars;

        } else {
            // Filter the registrars based on the search input
            this.searchRegistrars = this.filteredRegistrars.filter(registrar =>
                registrar.toLowerCase().includes(filterValue.toLowerCase())
            );
        }
    }

    applyRegisterforSearch(filterValue: string) {
        let result = this.shippersArr.filter(v => v.name.toLowerCase().indexOf(filterValue.toLocaleLowerCase()) > -1);
        this.searchedRegisterFor = result;
    }

    applyVehicleTypeSearch(filterValue: string) {
        let result = this.vehicleTypes.filter(v => v.viewValue.toLowerCase().indexOf(filterValue.toLocaleLowerCase()) > -1);
        this.searchedVehicleType = result;
    }

    removeGps() {
        this.selectedGPSProvider = '';
    }

    getRcPassingTareWeight(vehiclenumber) {
        this.showLoader = true;
        this.vehicle_qty = true;
        this.rc_Laden_weight = true;
        this.http.post('v1/captain/LicenseVehicleValidation/vehicleRCDetails', { vehiclenumber }).subscribe(
            (response: any) => {
                if (response.statusCode === 200) {
                    this.showLoader = false;
                    const temp: any = {};
                    const res = response.data && response.data.data;
                    (res && res.rc_passing_weight) ? this.capacityData.vehicle_qty = parseFloat((res.rc_passing_weight / 1000).toFixed(2)) : 0;
                    (res && res.tare_weight) ? this.capacityData.rc_Laden_weight = (res.tare_weight / 1000) : 0;
                    this.sub(this.capacityData);
                    this.vehicle_qty = false;
                    this.rc_Laden_weight = false;
                    if (res.chassis_number) this.spotVehicleData.chassis_number = res.chassis_number;
                    if (res.engine_number) this.spotVehicleData.engine_number = res.engine_number;
                    if (res.insurance.policy_number) this.insurance.no = res.insurance.policy_number;
                } else {
                }
            },
            (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
                this.showLoader = false;
                if (err.error.statusCode == 401) {
                    this.valid.logout();
                }
            }
        );
    }

    verifyDriver() {
        if (!this.spotVehicleData.driver_licence_no) {
            this.snackbar.openSnackBar('Please enter driver licence number', '', 'err');
            return;
        }
        this.showLoader = true;
        console.log(this.driverDob);
        const driverDobDate = typeof this.driverDob === 'string' ? new Date(this.driverDob) : this.driverDob;

        driverDobDate.setHours(driverDobDate.getHours() + 5);
        driverDobDate.setMinutes(driverDobDate.getMinutes() + 30);

        const payload = {
            dlnumber: this.spotVehicleData.driver_licence_no,
            ...(this.driverDob && { dob: driverDobDate })
        };
        this.http.post('v1/captain/LicenseVehicleValidation/driverLicense', payload).subscribe(
            (response: any) => {
                if (response.statusCode === 200) {
                    this.is_driver_verified = true;
                    this.showLoader = false;
                    const temp: any = {};
                    const res = response.data && response.data.data;

                    this.spotVehicleData.name = res.full_name;
                    this.expiryDate = new Date(res.license.expiry);
                    this.dlIssueDate = res.dl_issue_date;
                    this.sarathi_image = res.photo;
                    this.driverDob = new Date(res.date_of_birth);
                    this.driverImage = res.photo;
                }
            },
            (err: any) => {
                this.is_driver_verified = false;
                this.snackbar.openSnackBar(err.error.message, '', 'err');
                this.showLoader = false;
                if (err.error.statusCode == 401) {
                    this.valid.logout();
                }
            }
        );
    }
}